import type { ReactNode } from 'react'
import {
  Hand,
  MousePointer2,
  UnlockIcon,
  StickyNote,
  Pencil,
  RectangleHorizontal,
  Type,
  MessageSquareText,
  ZoomIn,
  ZoomOut,
} from 'lucide-react'

const TOOL_TRANSLATION_KEYS = {
  select: 'board:toolbar.tools.select',
  move: 'board:toolbar.tools.move',
  sticky_note: 'board:toolbar.tools.sticky_note',
  draw: 'board:toolbar.tools.draw',
  rectangle: 'board:toolbar.tools.rectangle',
  text: 'board:toolbar.tools.text',
  comment: 'board:toolbar.tools.comment',
  zoom: 'board:toolbar.tools.zoom',
  zoom_out: 'board:toolbar.tools.zoom_out',
  unlock: 'board:toolbar.tools.unlock',
} as const satisfies Record<string, `board:toolbar.tools.${string}`>

export type ToolbarTranslationKey =
  (typeof TOOL_TRANSLATION_KEYS)[keyof typeof TOOL_TRANSLATION_KEYS]

export interface ToolbarItem {
  icon: ReactNode
  type: string
  nameKey: ToolbarTranslationKey
  disabled?: boolean
}

const ICON_SIZE = 22

export const TOOLS: ToolbarItem[] = [
  {
    icon: <MousePointer2 size={ICON_SIZE} />,
    type: 'select',
    nameKey: TOOL_TRANSLATION_KEYS.select,
  },
  {
    icon: <Hand size={ICON_SIZE} />,
    type: 'hand',
    nameKey: TOOL_TRANSLATION_KEYS.move,
  },
  {
    icon: <ZoomIn size={ICON_SIZE} />,
    type: 'zoom',
    nameKey: TOOL_TRANSLATION_KEYS.zoom,
  },
  {
    icon: <ZoomOut size={ICON_SIZE} />,
    type: 'zoom-out',
    nameKey: TOOL_TRANSLATION_KEYS.zoom_out,
  },
  {
    icon: <StickyNote size={ICON_SIZE} />,
    type: 'note',
    nameKey: TOOL_TRANSLATION_KEYS.sticky_note,
  },
  {
    icon: <Pencil size={ICON_SIZE} />,
    type: 'draw',
    nameKey: TOOL_TRANSLATION_KEYS.draw,
  },
  {
    icon: <RectangleHorizontal size={ICON_SIZE} />,
    type: 'geo',
    nameKey: TOOL_TRANSLATION_KEYS.rectangle,
  },
  {
    icon: <Type size={ICON_SIZE} />,
    type: 'text',
    nameKey: TOOL_TRANSLATION_KEYS.text,
  },
  {
    icon: <MessageSquareText size={ICON_SIZE} />,
    type: 'comment',
    nameKey: TOOL_TRANSLATION_KEYS.comment,
  },
]

export const LOCKED_TOOLS: ToolbarItem[] = [
  {
    icon: <UnlockIcon size={ICON_SIZE} />,
    type: 'unlock',
    nameKey: TOOL_TRANSLATION_KEYS.unlock,
  },
  {
    icon: <MousePointer2 size={ICON_SIZE} />,
    type: 'select',
    nameKey: TOOL_TRANSLATION_KEYS.select,
  },
  {
    icon: <Hand size={ICON_SIZE} />,
    type: 'hand',
    nameKey: TOOL_TRANSLATION_KEYS.move,
  },
]
